<template>
  <div class="bd">
    <!-- src="https://www.thingjs.com/s/2e379ee6e7cf06dd9eaa19ad" -->
    <div class="main">
      <div class="left" :style="'height:' + screenHeight">
        <div class="left-content" style="height: 25%">
          <div class="type-title">
            <div>供应商信息</div>
          </div>
          <div class="left-supplier">
            <div
              class="left-supplier-supplieritme"
              v-for="item in supplierData"
              :key="item.name"
            >
              <div class="supplier-name">{{ item.name }}</div>
              <div class="supplier-count">{{ item.count + "   家" }}</div>
            </div>
          </div>
        </div>
        <div
          class="left-content slip_out_animation"
          style="padding-top: 0px; height: 38%"
        >
          <div class="type-title">
            <div>累计拆解</div>
            <div>
              <el-date-picker
                v-model="valueLeftTop"
                type="daterange"
                range-separator="~"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :clearable="false"
              >
              </el-date-picker>
            </div>
          </div>
          <div style="margin-top: 10px; padding-left: 20px">
            当前累计拆卸量：3147万台
          </div>
          <div class="left-echarts-1" id="left-echarts-1"></div>
        </div>
        <div class="left-content slip_out_animation" style="height: 38%">
          <div class="type-title">
            <div>年度处理量</div>
            <div style="width: 100px">
              <el-select v-model="valueLeftBottom" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="left-echarts-2" id="left-echarts-2"></div>
        </div>
      </div>
      <div class="middle" :style="'height:' + screenHeight">
        <div class="middle-content">
          <div class="type-title">
            <div>拆解信息</div>
          </div>
          <div class="middle-top-box">
            <div class="top-box-item">
              <div class="item-title">
                <img
                  class="img"
                  src="@/assets/images/right-icon1.png"
                  alt=""
                  srcset=""
                />
                <span>回收量</span>
              </div>
              <div class="item-content">
                <div class="item">2300 <span class="itemspan">万台</span></div>
                <div class="item">3451 <span class="itemspan">吨</span></div>
              </div>
            </div>
            <div class="top-box-item">
              <div class="item-title">
                <img
                  class="img"
                  src="@/assets/images/right-icon2.png"
                  alt=""
                  srcset=""
                />
                <span>拆解</span>
              </div>
              <div class="item-content">
                <div class="item">3400 <span class="itemspan">万台</span></div>
                <div class="item">5111 <span class="itemspan">吨</span></div>
              </div>
            </div>
          </div>
          <div class="middle-center-box">
            <div class="middle-center-item">
              <div class="title">CRT黑白电视机</div>
              <div class="info">
                <div class="">
                  <div>回收</div>
                  <div>拆解</div>
                  <div>留存</div>
                </div>
                <div>
                  <div>5</div>
                  <div>0</div>
                  <div>423</div>
                </div>
              </div>
            </div>

            <div class="middle-center-item">
              <div class="title">CRT彩色电视机</div>
              <div class="info">
                <div class="">
                  <div>回收</div>
                  <div>拆解</div>
                  <div>留存</div>
                </div>
                <div>
                  <div>5</div>
                  <div>0</div>
                  <div>423</div>
                </div>
              </div>
            </div>

            <div class="middle-center-item">
              <div class="title">液晶电视机</div>
              <div class="info">
                <div class="">
                  <div>回收</div>
                  <div>拆解</div>
                  <div>留存</div>
                </div>
                <div>
                  <div>5</div>
                  <div>0</div>
                  <div>423</div>
                </div>
              </div>
            </div>

            <div class="middle-center-item">
              <div class="title">冰箱</div>
              <div class="info">
                <div class="">
                  <div>回收</div>
                  <div>拆解</div>
                  <div>留存</div>
                </div>
                <div>
                  <div>5</div>
                  <div>0</div>
                  <div>423</div>
                </div>
              </div>
            </div>

            <div class="middle-center-item">
              <div class="title">冰柜</div>
              <div class="info">
                <div class="">
                  <div>回收</div>
                  <div>拆解</div>
                  <div>留存</div>
                </div>
                <div>
                  <div>5</div>
                  <div>0</div>
                  <div>423</div>
                </div>
              </div>
            </div>
            <div class="middle-center-item">
              <div class="title">空调</div>
              <div class="info">
                <div class="">
                  <div>回收</div>
                  <div>拆解</div>
                  <div>留存</div>
                </div>
                <div>
                  <div>5</div>
                  <div>0</div>
                  <div>423</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="middle-content" style="padding-bottom: unset">
          <div class="type-title">
            <div>累计产出：3306吨</div>
            <div>
              <el-date-picker
                v-model="valueCenterTop"
                type="daterange"
                range-separator="~"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :clearable="false"
              >
              </el-date-picker>
            </div>
          </div>
          <div class="middle-bottom-box">
            <!-- <div class="bottom-item">
              <div class="title">今日注销</div>
              <div class="info">35台</div>
            </div>
            <div class="bottom-item">
              <div class="title">今日注销</div>
              <div class="info">35台</div>
            </div>
            <div class="bottom-item">
              <div class="title">今日注销</div>
              <div class="info">35台</div>
            </div> -->
            <div class="center-echarts-1" id="center-echarts-1"></div>
          </div>
        </div>
      </div>
      <div class="right" :style="'height:' + screenHeight">
        <div class="right-content slip_in_animation" style="height: 35vh">
          <div class="type-title">
            <div>商家排行榜</div>
          </div>

          <div
            class="right-top"
            v-for="(item, index) in Company"
            :key="item.name"
          >
            <span class="right-t">top{{ index + 1 }}</span>
            <span>{{ item.name }}</span>
          </div>

          <!-- <div style="margin-top: 30px; padding-left: 20px">
            累计产出：3147吨
          </div>
          <div id="right-echarts-2" class="right-echarts-2"></div> -->
        </div>

        <div class="right-content slip_in_animation">
          <div class="type-title">
            <div>销售信息</div>
          </div>
          <div id="right-echarts-1" class="right-echarts-1"></div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
// import "swiper/css/swiper.css"; //引入swiper样式
import Swiper from "swiper"; //引入swiper
import "swiper/dist/css/swiper.css";
import * as echarts from "echarts";

export default {
  name: "indexModelTwo",
  props: ["screenHeight"],
  data() {
    return {
      Company: [
        {
          name: "益珠再生资源回收公司",
        },
        {
          name: "青川再生资源回收公司",
        },
        {
          name: "骞昊再生资源回收公司",
        },
        {
          name: "安碧再生资源回收公司",
        },
        {
          name: "复施特再生资源回收公司",
        },
        {
          name: "米加再生资源回收公司",
        },
        {
          name: "麦森再生资源回收公司",
        },
      ],
      supplierData: [
        { name: "供应商总数", count: 200 },
        { name: "大型供应商", count: 125 },
        { name: "小型供应商", count: 75 },
      ],
      optionCenter: {
        xAxis: {
          type: "category",
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: [120, 200, 150, 80, 70, 110, 130],
            type: "bar",
          },
        ],
      },
      selectIndex: 1,
      nowTime: "",
      valueLeftTop: ["2023-01-03", "2023-01-20"],
      valueCenterTop: ["2023-01-03", "2023-01-20"],

      valueRightTop: ["2023-01-03", "2023-01-20"],
      valueLeftBottom: "7",
      options: [
        {
          value: "1",
          label: "2017",
        },
        {
          value: "2",
          label: "2018",
        },
        {
          value: "3",
          label: "2019",
        },
        {
          value: "4",
          label: "2020",
        },
        {
          value: "5",
          label: "2021",
        },
        {
          value: "6",
          label: "2022",
        },
        {
          value: "7",
          label: "2023",
        },
      ],
      valueRightBottom: "7",
      optionsRight: [
        {
          value: "1",
          label: "2017",
        },
        {
          value: "2",
          label: "2018",
        },
        {
          value: "3",
          label: "2019",
        },
        {
          value: "4",
          label: "2020",
        },
        {
          value: "5",
          label: "2021",
        },

        {
          value: "6",
          label: "2022",
        },
        {
          value: "7",
          label: "2023",
        },
      ],
    };
  },
  mounted() {
    setTimeout(() => {
      this.$nextTick(() => {
        this.createdCarEchartsLeftTop();
        this.createdCarEchartsLeftBottom();
        this.createdCarEchartsRightBottom();
        this.createdCarEchartsCenterBottom();
      });
    }, 200);
  },
  methods: {
    // 饼图
    createdCarEchartsLeftTop() {
      var leftEchartsTOP = document.getElementById("left-echarts-1");
      var myChart = echarts.init(leftEchartsTOP);
      var option;

      option = {
        title: {
          subtext: "单位：万台",
          left: "right",
          subtextStyle: {
            color: "#FFF",
          },
        },

        tooltip: {
          trigger: "item",
          formatter: function (params) {
            return (
              params.name +
              ":  " +
              params.data.value +
              "（" +
              params.percent +
              "%）"
            );
          },
        },
        color: [
          "#5470c6",
          "#91cc75",
          "#fac858",
          "#ee6666",
          "#73c0de",
          "#3ba272",
          "#fc8452",
          "#9a60b4",
          "#ea7ccc",
        ],
        legend: {
          // show: false,
          bottom: "0",
          textStyle: {
            fontSize: 12,
            color: "#FFFFFF",
          },
        },
        series: [
          {
            name: "数量",
            type: "pie",
            radius: "50%",
            data: [
              { value: 1048, name: "冰箱" },
              { value: 735, name: "洗衣机" },
              { value: 580, name: "电脑" },
              { value: 484, name: "电视机" },
              { value: 300, name: "空调" },
            ],
            label: {
              color: "#FFF",
              formatter(param) {
                return param.data.value;
              },
            },
          },
        ],
      };

      option && myChart.setOption(option);
    },
    // 折线图
    createdCarEchartsLeftBottom() {
      var leftEchartsTOP = document.getElementById("left-echarts-2");

      var myChart = echarts.init(leftEchartsTOP);
      var option;

      option = {
        tooltip: {
          trigger: "axis",
        },
        color: [
          "#5470c6",
          "#91cc75",
          "#fac858",
          "#ee6666",
          "#73c0de",
          "#3ba272",
          "#fc8452",
          "#9a60b4",
          "#ea7ccc",
        ],
        legend: {
          // show: false,
          bottom: "bottom",
          textStyle: {
            fontSize: 12,
            color: "#FFFFFF",
          },
        },
        grid: {
          top: "5%",
          left: "3%",
          right: "4%",
          bottom: "15%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [
            "一月",
            "二月",
            "三月",
            "四月",
            "五月",
            "六月",
            "七月",
            "八月",
            "九月",
            "十月",
            "十一月",
            "十二月",
          ],
          axisLabel: {
            interval: 1,
            color: "#fff",
          },
          axisLine: {
            lineStyle: {
              // color: "#fff",
              color: "#094060",
            },
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            color: "#ffffff",
          },
          axisLine: {
            lineStyle: {
              // color: "#fff",
              color: "#094060",
            },
          },
        },
        series: [
          {
            name: "冰箱",
            type: "line",
            stack: "Total",
            smooth: true,
            data: [4, 13, 230, 13, 9, 23, 21, 12, 12, 300, 13, 3, 23, 21],
          },
          {
            name: "洗衣机",
            type: "line",
            stack: "Total",
            smooth: true,
            data: [22, 82, 300, 24, 90, 30, 10, 30, 11, 24, 29, 33, 30],
          },
          {
            name: "电脑",
            type: "line",
            stack: "Total",
            smooth: true,
            data: [15, 23, 20, 14, 19, 30, 10, 23, 3, 14, 19, 30, 40],
          },
          {
            name: "电视机",
            type: "line",
            stack: "Total",
            smooth: true,
            data: [32, 33, 31, 34, 30, 30, 20, 32, 10, 34, 30, 33, 32],
          },
          {
            name: "空调",
            type: "line",
            stack: "Total",
            smooth: true,
            data: [80, 93, 91, 94, 120, 130, 130, 32, 90, 94, 120, 330, 120],
          },
        ],
      };

      option && myChart.setOption(option);
    },
    // 柱形图
    createdCarEchartsRightBottom() {
      var leftEchartsTOP = document.getElementById("right-echarts-1");
      var myChart = echarts.init(leftEchartsTOP);
      var option;

      option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            label: {
              show: true,
            },
          },
        },
        color: [
          "#5470c6",
          "#91cc75",
          "#fac858",
          "#ee6666",
          "#73c0de",
          "#3ba272",
          "#fc8452",
          "#9a60b4",
          "#ea7ccc",
        ],
        calculable: true,

        legend: {
          // show: false,
          data: ["Growth", "销售重量（吨）", "销售金额（元）"],
          itemGap: 5,
          bottom: "bottom",
          textStyle: {
            fontSize: 12,
            color: "#FFFFFF",
          },
        },
        grid: {
          top: "6%",
          left: "3%",
          right: "4%",
          bottom: "15%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: [2017, 2018, 2019, 2020, 2021],
            axisLabel: {
              color: "#fff",
            },
            axisLine: {
              lineStyle: {
                // color: "#fff",
                color: "#094060",

              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              color: "#fff",
            },
            axisLine: {
              lineStyle: {
                // color: "#fff",
                color: "#094060",

              },
            },
          },
        ],
        series: [
          {
            name: "销售重量（吨）",
            type: "bar",
            barGap: "0%",
            data: [223, 659, 2855, 1152, 666],
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  position: "top", //在上方显示
                  formatter: function (val) {
                    if (val.value == 0) {
                      return "";
                    }
                  },
                  textStyle: {
                    //数值样式
                    color: "white",
                    fontSize: 12,
                  },
                },
              },
            },
          },
          {
            name: "销售金额（元）",
            type: "bar",
            data: [99, 56, 1233, 846, 999],
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  position: "top", //在上方显示
                  formatter: function (val) {
                    if (val.value == 0) {
                      return "";
                    }
                  },
                  textStyle: {
                    //数值样式
                    color: "white",
                    fontSize: 12,
                  },
                },
              },
            },
          },
        ],
      };

      option && myChart.setOption(option);
    },

    //中间
    createdCarEchartsCenterBottom() {
      var chartDom = document.getElementById("center-echarts-1");
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            label: {
              show: true,
            },
          },
        },
        color: [
          "#5470c6",
          "#91cc75",
          "#fac858",
          "#ee6666",
          "#73c0de",
          "#3ba272",
          "#fc8452",
          "#9a60b4",
          "#ea7ccc",
        ],
        calculable: true,

        legend: {
          show: false,
          // data: ["Growth", "销售重量（吨）", "销售金额（元）"],
          itemGap: 5,
          bottom: "bottom",
          textStyle: {
            fontSize: 12,
            color: "#FFFFFF",
          },
        },
        grid: {
          top: "6%",
          left: "3%",
          right: "4%",
          bottom: "10%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: [
              "铜电机",
              "铝电机",
              "锥玻璃",
              "屏玻璃",
              "保温材料",
              "废铜",
              "废铁",
              "废铝",
              "塑料",
              "电线电缆",
              "废弃零部件",
              "空调冷凝器",
              "电路板",
            ],
            axisLabel: {
              color: "#fff",
            },
            axisLine: {
              lineStyle: {
                // color: "#fff",
                color: "#094060",

              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              color: "#fff",
            },
            axisLine: {
              lineStyle: {
                // color: "#fff",
                color: "#094060",

              },
            },
          },
        ],
        dataZoom: [
          {
            type: "inside",
            // 数据窗口范围的起始百分比
            start: 0,
            // 数据窗口范围的结束百分比
            end: 50,
            // 是否锁定选择区域（或叫做数据窗口）的大小，如果设置为 true 则锁定选择区域的大小，也就是说，只能平移，不能缩放
            zoomLock: true,

            xAxisIndex: [0],
          },
          // 手柄的icon相关配置
          {
            height: 8,
            bottom: 8,
            textStyle: { color: '#fff' },
            handleIcon:
              "M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z",
            handleSize: "80%",
            color:'#fff',
            handleStyle: {
              color: "#fff",
              shadowBlur: 3,
              shadowColor: "rgba(0, 0, 0, 0.6)",
              shadowOffsetX: 2,
              shadowOffsetY: 2,
            },
          },
        ],
        series: [
          {
            name: "数据",
            type: "bar",
            data: [
              223, 659, 2055, 1152, 666, 666, 566, 666, 1266, 666, 616, 966,
              866,
            ],
            barWidth: '50%',//设置柱状图的柱状的宽度
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  position: "top", //在上方显示
                  formatter: function (val) {
                    if (val.value == 0) {
                      return "";
                    }
                  },
                  textStyle: {
                    //数值样式
                    color: "white",
                    fontSize: 12,
                  },
                },
              },
            },
          },
        ],
      };

      option && myChart.setOption(option);
    },
  },
};
</script>
  <style scoped>
::-webkit-scrollbar {
  width: 0px;
}

.swiper-pagination-bullet-active {
  background-color: orangered;
}
.iframe {
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: -1;
}
.head .title {
  flex: 1;
  color: #fff;
  text-align: center;
  font-size: 32px;
  padding-top: 15px;
}
.head .nowtime {
  color: #fff;
  position: absolute;
  right: 30px;
  top: 30px;
}
.main {
  display: flex;
  align-items: center;
  background: rgba(17, 47, 107, 0.6);
  width: 98.5vw;
  margin: 0 auto;
}
.main .left,
.main .right {
  width: 520px;
  height: 75vh;

  overflow: hidden;
}
.main .left {
  /* float: left; */
  margin-left: 20px;
}
.main .right {
  /* float: right; */
  margin-right: 20px;
}
.main .left .left-content {
  box-sizing: border-box;
  padding: 20px;
  color: #fff;
  /* height: 50%; */
  height: 33%;
}
::v-deep .main .left .left-content .type-title,
.main .right .right-content .type-title,
.main .middle .middle-content .type-title {
  font-size: 22px;
  margin-bottom: 10px;
  border-left: 6px rgb(115, 95, 250) solid;
  padding-left: 15px;
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.left .left-supplier {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0 20px;
}
.left .left-supplier .left-supplier-supplieritme {
  width: 50%;
  /* text-align: center; */
  font-size: 18px;
  margin-top: 5px;
  box-sizing: border-box;
}
.supplier-name {
  margin-bottom: 5px;
}
.supplier-count {
  /* text-align: center; */
  padding-left: 20px;
}

.main .right .right-content {
  padding: 20px;
  color: #fff;
  height: 50%;
}

.main .right .right-content .right-content-center {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
}

.main .right .right-content .right-bottom-content {
  overflow-y: scroll;
  scroll-behavior: smooth;
  overscroll-behavior: contain;
  height: 35vh;
}

.main .right .right-content .right-bottom-content .right-bottom-content-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 20px;
  color: #fff;
  padding: 20px 0;
  border-bottom: 1px rgb(55, 51, 51) dotted;
}

.right-top-item {
  box-sizing: border-box;
}
.right-top-item-title {
  display: flex;
  align-items: center;
  font-size: 24px;
}
.right-top-item-title img {
  width: 60px;
  height: 60px;
  margin-right: 5px;
}
.right-top-item-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 30px;
  margin-top: 10px;
  font-size: 30px;
}
.right-top {
  font-size: 20px;
  margin: 20px 20px;
}
.right-t {
  margin-right: 20px;
}
.middle {
  flex: 1;
  height: 75vh;
}
.middle-content {
  padding: 20px;
  padding-bottom: unset;
}
.middle-content .type-title {
  font-size: 22px;
  margin-bottom: 10px;
  border-left: 6px rgb(115, 95, 250) solid;
  padding-left: 15px;
  color: #fff;
}
.middle-content .middle-top-box {
  display: flex;
  justify-content: space-between;
  color: #fff;
  /* padding-top: 30px;
  margin-bottom: 30px; */
}
.middle-content .middle-top-box .top-box-item {
  width: 50%;
}
.middle-content .middle-top-box .top-box-item .item-title {
  display: flex;
  align-items: center;
  font-size: 26px;
}
.middle-content .middle-top-box .top-box-item .item-title img {
  width: 60px;
  height: 60px;
}
.middle-content .middle-top-box .top-box-item .item-content {
  display: flex;
  flex-wrap: wrap;
}
.middle-content .middle-top-box .top-box-item .item-content .item {
  width: 50%;
  font-size: 34px;
  margin-top: 10px;
}
.middle-content .middle-top-box .top-box-item .item-content .itemspan {
  font-size: 22px;
}
.middle-center-box {
  padding: 10px 0;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  height: 29vh;
  overflow-y: scroll;
  scroll-behavior: smooth;
  overscroll-behavior: contain;
}
.middle-center-box .middle-center-item {
  width: 30%;
  margin-right: 3%;
  margin-bottom: 1%;
}
.middle-center-box .middle-center-item .title {
  font-size: 28px;
  color: #51b5fd;
  margin-bottom: 10px;
}
.middle-center-box .middle-center-item .info {
  /* background: black; */
  color: #fff;
  width: 100%;
  border-radius: 10px;
}
.middle-center-box .middle-center-item .info > div {
  display: flex;
  text-align: center;
  padding: 10px;
  font-size: 20px;
}
.middle-center-box .middle-center-item .info > div > div {
  width: 33%;
}
.middle-bottom-box {
  display: flex;
  align-items: center;
  /* height: 30vh; */

  /* height: 25vh; */
}
.middle-bottom-box .bottom-item {
  width: 33%;
  text-align: center;
  font-size: 28px;
  color: #fff;
}
.middle-bottom-box .bottom-item .title {
  margin-bottom: 20px;
}
/* echarts */
/* 汽废左侧饼图 */
.left-echarts-1,
.left-echarts-2 {
  width: 100%;
  height: 80%;
}
.center-echarts-1 {
  width: 100%;
  /* height: 70%; */
  height: 20vh;
}
.right-echarts-1 {
  width: 100%;
  height: 70%;
}
.right-echarts-2 {
  width: 100%;
  height: 90%;
}
::v-deep .el-range-input {
  background: transparent !important;
}
::v-deep .el-input__inner {
  background: transparent !important;
  color: #fff !important;
}
::v-deep .el-date-editor .el-range-separator {
  color: #fff !important;
}
::v-deep .el-date-editor .el-range-input {
  color: #fff !important;
  width: 100px !important;
}
::v-deep .el-date-editor {
  width: 220px;
  padding: unset;
  box-sizing: border-box;
}
::v-deep .el-date-editor .el-range-separator {
  line-height: unset !important;
}
::v-deep .el-date-editor .el-range__icon {
  display: none !important;
}
</style>
  